import { ref, watch } from 'vue';
function useModel(value, onChange) {
  const localValue = ref(null);
  watch(value, val => {
    localValue.value = val;
  }, {
    immediate: true
  });
  watch(localValue, val => {
    onChange(val);
  });
  return localValue;
}
export { useModel };